import { apiFetch } from './client';
/** Saved per-clinic DICOM destinations (for the send dialog + config UI). */
export async function listDicomDestinations(clinicId) {
    return apiFetch(`/dicom/destinations?clinicId=${encodeURIComponent(clinicId)}`);
}
export async function createDicomDestination(clinicId, body) {
    return apiFetch('/dicom/destinations', {
        method: 'POST',
        body: JSON.stringify({ clinicId, ...body }),
    });
}
export async function updateDicomDestination(id, body) {
    return apiFetch(`/dicom/destinations/${encodeURIComponent(id)}`, {
        method: 'PUT',
        body: JSON.stringify(body),
    });
}
export async function deleteDicomDestination(id) {
    return apiFetch(`/dicom/destinations/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
/** Queue a study (or a series subset) for transfer. The actual C-STORE is async (server-side). */
export async function sendStudyDicom(studyId, body) {
    return apiFetch(`/dicom/studies/${encodeURIComponent(studyId)}/send`, {
        method: 'POST',
        body: JSON.stringify(body),
    });
}
/** Clinic-wide recent DICOM send activity (newest first). */
export async function getClinicDicomSendLog(clinicId, limit = 100) {
    return apiFetch(`/dicom/send-log?clinicId=${encodeURIComponent(clinicId)}&limit=${limit}`);
}
/** Verify a destination via a synchronous server-side C-ECHO. */
export async function testDicomConnection(body) {
    const { clinicId, ...rest } = body;
    const qs = clinicId ? `?clinicId=${encodeURIComponent(clinicId)}` : '';
    return apiFetch(`/dicom/test-connection${qs}`, {
        method: 'POST',
        body: JSON.stringify(rest),
    });
}
